export enum FilterTypes {
  INPUT_FIELD = 'input field',
  DROPDOWN_LIST = 'dropdown',
  CHECKBOX = 'checkbox',
  DATE_RANGE = 'date range',
  TIME = 'time'
}
